/**
 * #1969 — the staff document page's WIRE CONTRACT: the console route the engine links to,
 * and the two engine reads the page makes.
 *
 * <b>Dependency-free on purpose</b> (the `chatRoutes.ts` rule): zero imports, so the node-only
 * test tree (`tsconfig.integration.json`, `types: ["node"]`) can import the REAL builders
 * instead of mirroring a path it would then keep passing against after the page moved.
 *
 * Server side: `GET /internal/v0/documents/{documentId}` and `.../pdf` on the engine's
 * operator group (`platform/workflow-engine/Http/InternalApiEndpoints.cs`). The engine's
 * `render_document` tool returns the staff link `https://<console host>/documents/<id>`,
 * which is why the console route below must stay exactly `/documents/:documentId`.
 */

/** The console route (react-router pattern). The engine mints links to `/documents/<id>`. */
export const DOCUMENT_CONSOLE_ROUTE = "/documents/:documentId";

/** The console path the engine's staff link points at, for one document. */
export function documentConsolePath(documentId: string): string {
  return `/documents/${encodeURIComponent(documentId)}`;
}

/** `GET` — the document's metadata (JSON). */
export function documentMetadataPath(documentId: string): string {
  return `/internal/v0/documents/${encodeURIComponent(documentId)}`;
}

/** `GET` — the rendered PDF (`application/pdf`, strong ETag). */
export function documentPdfPath(documentId: string): string {
  return `${documentMetadataPath(documentId)}/pdf`;
}

/** The media type the page shows and downloads. */
export const PDF_MEDIA_TYPE = "application/pdf";
